// Resolves the correct API base URL at runtime.
// In production (custom domain alunotcs.com.br or *.emergent.host), use the
// current origin so that all API calls are SAME-ORIGIN. This eliminates
// cross-origin "Network Error" failures (CORS preflight + flaky DNS to
// the preview host) that users experience under their own domain.
// In local development (localhost), fall back to REACT_APP_BACKEND_URL.
export const API_BASE = (() => {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return process.env.REACT_APP_BACKEND_URL || window.location.origin;
  }
  return window.location.origin;
})();
